const INSTAGRAM_CLIENT_ID = process.env.REACT_APP_INSTAGRAM_CLIENT_ID;
const API_URL = process.env.REACT_APP_API_URL;

/**
 * Get the normalized origin, stripping "www." to ensure consistent redirect URIs.
 * This prevents OAuth failures when users access via www.nexbii.com vs nexbii.com.
 */
const getNormalizedOrigin = () => {
  if (typeof window === 'undefined') return 'https://nexbii.com';
  const origin = window.location.origin;
  return origin.replace('://www.', '://');
};

const getRedirectUri = () => {
  if (process.env.REACT_APP_INSTAGRAM_REDIRECT_URI) {
    return process.env.REACT_APP_INSTAGRAM_REDIRECT_URI;
  }
  return `${getNormalizedOrigin()}/auth/instagram/callback`;
};

export const initiateInstagramAuth = () => {
  if (!INSTAGRAM_CLIENT_ID) {
    throw new Error('Instagram Client ID is not configured');
  }

  const redirectUri = getRedirectUri();
  const scope = 'instagram_business_basic';
  const authUrl = new URL('https://www.instagram.com/oauth/authorize');

  authUrl.searchParams.append('client_id', INSTAGRAM_CLIENT_ID);
  authUrl.searchParams.append('redirect_uri', redirectUri);
  authUrl.searchParams.append('scope', scope);
  authUrl.searchParams.append('response_type', 'code');

  const width = 600;
  const height = 700;
  const left = window.innerWidth / 2 - width / 2;
  const top = window.innerHeight / 2 - height / 2;

  return window.open(
    authUrl.toString(),
    'instagram-auth',
    `width=${width},height=${height},left=${left},top=${top}`,
  );
};

/**
 * Exchange Instagram authorization code for user data via backend API.
 * Sends redirect_uri so backend uses the same one during token exchange.
 */
export const getInstagramAccessToken = async (code: string) => {
  const response = await fetch(`${API_URL}/api/auth/instagram/callback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ code, redirect_uri: getRedirectUri() }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Instagram authentication failed: ${response.status} - ${text}`);
  }

  return response.json();
};
